import { ApiRequestConfig, apiService } from './api.service';

import { IGroupMessageResponse } from '@/interfaces/entities/group-message';
import { IApiService } from '@/interfaces/services/IApiService';

class GroupMessageService {
	[x: string]: any;
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllMessagesByGroupId(uuid: string) {
		return await this.api.get<IGroupMessageResponse>(`/groups/${uuid}`);
	}

	async deleteGroupMessage(uuid: string) {
		return await this.api.delete(`/groups/message/${uuid}`);
	}
}

export const groupMessageService = new GroupMessageService(apiService);
